module.exports = __webpack_public_path__ + "img/logo-stripe.30f7fc93.svg";